export const ADD_QUEUE_POSITION = 'ADD_QUEUE_POSITION';
export const ADD_QUEUE_POSITION_SUCCESS = 'ADD_QUEUE_POSITION_SUCCESS';
export const ADD_QUEUE_POSITION_ERROR = 'ADD_QUEUE_POSITION_ERROR';
